var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5626 21.5598C17.4005 21.5597 17.2408 21.5204 17.0973 21.4451L12.0001 18.7654L6.90296 21.4451C6.73778 21.5319 6.55161 21.5708 6.3655 21.5573C6.17938 21.5438 6.00074 21.4786 5.84977 21.3689C5.6988 21.2593 5.58152 21.1095 5.51119 20.9367C5.44086 20.7639 5.42028 20.5748 5.45178 20.3909L6.42542 14.7151L2.30188 10.6961C2.1683 10.5658 2.07382 10.4008 2.02912 10.2196C1.98443 10.0384 1.99129 9.84837 2.04894 9.6709C2.10659 9.49343 2.21273 9.33563 2.35536 9.21532C2.498 9.09501 2.67144 9.01699 2.85608 8.99009L8.55482 8.16196L11.1031 2.9983C11.1952 2.84235 11.3264 2.71311 11.4837 2.62333C11.641 2.53355 11.819 2.48633 12.0001 2.48633C12.1812 2.48633 12.3592 2.53355 12.5165 2.62333C12.6738 2.71311 12.805 2.84235 12.8971 2.9983L15.4454 8.16187L21.1441 8.99C21.3288 9.0169 21.5022 9.09492 21.6449 9.21523C21.7875 9.33554 21.8936 9.49334 21.9513 9.67081C22.0089 9.84828 22.0158 10.0383 21.9711 10.2195C21.9264 10.4007 21.8319 10.5657 21.6983 10.696L17.5748 14.715L18.5484 20.3908C18.573 20.5343 18.566 20.6815 18.5278 20.8221C18.4896 20.9626 18.4212 21.0931 18.3273 21.2045C18.2334 21.3158 18.1163 21.4053 17.9842 21.4667C17.8521 21.528 17.7082 21.5598 17.5626 21.5598L17.5626 21.5598Z",
    fill: "#FD8A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.554fc4a589d99d539555bc51df080095.svg";
export { ForwardRef as ReactComponent };